"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.surveyAnalyticsGetApi = surveyAnalyticsGetApi;
exports.surveyAnalyticsSaveApi = surveyAnalyticsSaveApi;
exports.surveyAnalyticsUpdateApi = surveyAnalyticsUpdateApi;
exports.surveyApproveApi = surveyApproveApi;
exports.surveyApproveBulkApi = surveyApproveBulkApi;
exports.surveyCopyUrlApi = surveyCopyUrlApi;
exports.surveyCreateApi = surveyCreateApi;
exports.surveyDeleteApi = surveyDeleteApi;
exports.surveyDeleteBulkApi = surveyDeleteBulkApi;
exports.surveyDownloadAllApi = surveyDownloadAllApi;
exports.surveyDownloadSurveyResponseApi = surveyDownloadSurveyResponseApi;
exports.surveyErrorSheetDownloadApi = surveyErrorSheetDownloadApi;
exports.surveyFetchApi = surveyFetchApi;
exports.surveyFetchConfigurationApi = surveyFetchConfigurationApi;
exports.surveyFetchPasscodeApi = surveyFetchPasscodeApi;
exports.surveyImportApi = surveyImportApi;
exports.surveyLinkedFundApi = surveyLinkedFundApi;
exports.surveyListApi = surveyListApi;
exports.surveyListConfigurationApi = surveyListConfigurationApi;
exports.surveyListReviewAndApproveApi = surveyListReviewAndApproveApi;
exports.surveyLockApi = surveyLockApi;
exports.surveyLockBulkApi = surveyLockBulkApi;
exports.surveyMagicUrlApi = surveyMagicUrlApi;
exports.surveyPauseApi = surveyPauseApi;
exports.surveyPauseBulkApi = surveyPauseBulkApi;
exports.surveyPrefightApi = surveyPrefightApi;
exports.surveyRestoreApi = surveyRestoreApi;
exports.surveyRestoreBulkApi = surveyRestoreBulkApi;
exports.surveyResumeApi = surveyResumeApi;
exports.surveyResumeBulkApi = surveyResumeBulkApi;
exports.surveySaveLinkedFundApi = surveySaveLinkedFundApi;
exports.surveySoftDeleteApi = surveySoftDeleteApi;
exports.surveySoftDeleteBulkApi = surveySoftDeleteBulkApi;
exports.surveySoftDeleteListApi = surveySoftDeleteListApi;
exports.surveySubmitApi = surveySubmitApi;
exports.surveySubmitBulkApi = surveySubmitBulkApi;
exports.surveyUnlockApi = surveyUnlockApi;
exports.surveyUnlockBulkApi = surveyUnlockBulkApi;
exports.surveyUpdateApi = surveyUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
function surveyListApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.list), payload);
}

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
function surveyFetchApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.fetch), payload);
}

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
function surveyFetchPasscodeApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.fetchPasscode), payload);
}

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
function surveyCreateApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.create), payload);
}

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 * @param data
 */
function surveyUpdateApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.update), payload);
}

/**
 * Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Linked Fund.
 */
function surveyLinkedFundApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.linkedFund), payload);
}

/**
 * Save Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Save Linked Fund.
 */
function surveySaveLinkedFundApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.saveLinkedFund), payload);
}

/**
 * Lock
 * @param payload
 * @returns api response
 * @description this function used to Lock.
 */
function surveyLockApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.lock), payload);
}

/**
 * Lock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Lock Bulk.
 */
function surveyLockBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.lockBulk), payload);
}

/**
 * Unlock
 * @param payload
 * @returns api response
 * @description this function used to Unlock.
 */
function surveyUnlockApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.unlock), payload);
}

/**
 * Unlock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Unlock Bulk.
 */
function surveyUnlockBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.unlockBulk), payload);
}

/**
 * Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete.
 */
function surveySoftDeleteApi(payload) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.softDelete), payload);
}

/**
 * Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete Bulk.
 */
function surveySoftDeleteBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.softDeleteBulk), payload);
}

/**
 * Submit
 * @param payload
 * @returns api response
 * @description this function used to Submit.
 */
function surveySubmitApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.submit), payload);
}

/**
 * Submit Bulk
 * @param payload
 * @returns api response
 * @description this function used to Submit Bulk.
 */
function surveySubmitBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.submitBulk), payload);
}

/**
 * Pause
 * @param payload
 * @returns api response
 * @description this function used to Pause.
 */
function surveyPauseApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.pause), payload);
}

/**
 * Pause Bulk
 * @param payload
 * @returns api response
 * @description this function used to Pause Bulk.
 */
function surveyPauseBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.pauseBulk), payload);
}

/**
 * Resume
 * @param payload
 * @returns api response
 * @description this function used to Resume.
 */
function surveyResumeApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.resume), payload);
}

/**
 * Resume Bulk
 * @param payload
 * @returns api response
 * @description this function used to Resume Bulk.
 */
function surveyResumeBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.resumeBulk), payload);
}

/**
 * Copy Url
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
function surveyCopyUrlApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.copyUrl), payload);
}

/**
 * Magic Url
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
function surveyMagicUrlApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.magicUrl), payload);
}

/**
 * Download All
 * @param payload
 * @returns api response
 * @description this function used to Download All.
 */
function surveyDownloadAllApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.downloadAll), payload);
}

/**
 * Download Survey Response
 * @param payload
 * @returns api response
 * @description this function used to Download Survey Response.
 */
function surveyDownloadSurveyResponseApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.downloadSurveyResponse), payload);
}

// deleted data

/**
 * Soft Delete List
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete List.
 */
function surveySoftDeleteListApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.softDeleteList), payload);
}

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
function surveyRestoreApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.restore), payload);
}

/**
 * Restore Bulk
 * @param payload
 * @returns api response
 * @description this function used to Restore Bulk.
 */
function surveyRestoreBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.restoreBulk), payload);
}

/**
 * Delete
 * @param payload
 * @returns api response
 * @description this function used to Delete.
 */
function surveyDeleteApi(payload) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.delete), payload);
}

/**
 * Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Delete Bulk.
 */
function surveyDeleteBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.deleteBulk), payload);
}

// Uploader

/**
 * Prefight
 * @param payload
 * @returns api response
 * @description this function used to Prefight.
 */
function surveyPrefightApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.prefight), payload);
}

/**
 * Import
 * @param payload
 * @returns api response
 * @description this function used to Import.
 */
function surveyImportApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.import), payload);
}

/**
 * Error Sheet Download
 * @param payload
 * @returns api response
 * @description this function used to Error Sheet Download.
 */
function surveyErrorSheetDownloadApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.errorSheetDownload), payload);
}

// analytics

/**
 * Analytics Save
 * @param payload
 * @returns api response
 * @description this function used to Analytics Save.
 */
function surveyAnalyticsSaveApi(payload) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.analyticsSave), payload);
}

/**
 * Analytics Get
 * @param payload
 * @returns api response
 * @description this function used to Analytics Get.
 */
function surveyAnalyticsGetApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.analyticsGet), payload);
}

/**
 * Analytics Update
 * @param payload
 * @returns api response
 * @description this function used to Analytics Update.
 */
function surveyAnalyticsUpdateApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.analyticsUpdate), payload);
}

/**
 * List Configuration
 * @param payload
 * @returns api response
 * @description this function used to List Configuration.
 */
function surveyListConfigurationApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.listConfiguration), payload);
}

/**
 * Fetch Configuration
 * @param payload
 * @returns api response
 * @description this function used to Fetch Configuration.
 */
function surveyFetchConfigurationApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.fetchConfiguration), payload);
}

/**
 * List Review And Approve
 * @param payload
 * @returns api response
 * @description this function used to List Review And Approve.
 */
function surveyListReviewAndApproveApi(payload) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.listReviewAndApprove), payload);
}

/**
 * Approve
 * @param payload
 * @returns api response
 * @description this function used to Approve.
 */
function surveyApproveApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.approve), payload);
}

/**
 * Approve Bulk
 * @param payload
 * @returns api response
 * @description this function used to Approve Bulk.
 */
function surveyApproveBulkApi(payload) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SurveyorService.survey.approveBulk), payload);
}